import * as React from "react";
import type { SVGProps } from "react";
const SvgExclamationInSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 15c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1M11.62 17.92c.12.06.25.08.38.08.26 0 .52-.11.71-.29l.042-.05a.757.757 0 0 0 .168-.28c.03-.06.06-.12.06-.18.02-.07.02-.14.02-.2 0-.062-.008-.116-.017-.177l-.003-.023a.6.6 0 0 0-.06-.18.6.6 0 0 0-.09-.17.6.6 0 0 0-.087-.12l-.033-.04c-.28-.28-.73-.37-1.09-.21q-.18.075-.33.21l-.033.04a.6.6 0 0 0-.087.12c-.04.05-.07.11-.09.17q-.045.09-.06.18c-.02.07-.02.13-.02.2q.001.044.01.092.009.053.01.108.015.09.06.18a.8.8 0 0 0 .168.28l.042.05q.15.135.33.21"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 22c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4zM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgExclamationInSquare;
